export default "__VITE_ASSET__4f5cb023__"